import React, { useState, useEffect, useContext, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useFetch, usePost } from '../../../components/component-items/helpers'
import { globalState } from '../../../store'
import Clipboard from 'react-clipboard-animation'
import { useTheme } from 'styled-components'
import GenericModal from '../../../components/component-items/modal'

// Components
import GlobalStyles from '../../../components/component-items/styles'
import { TableRow } from '../../orders/styles'
import { TableCell } from '../../../components/component-items/datatable'
import { StatusBarStyled } from '../../../components/component-items/status-bar'
import { ModalProps } from './types'

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRecycle, faInfoSquare } from '@fortawesome/pro-duotone-svg-icons'

export const ApiKeysModal = ({ open, setOpen }: ModalProps) => {
  const theme = useTheme()
  const [copied, setCopied] = useState(false)

  const {
    state: { csrf, companyId },
  } = globalState()

  const fetchUrl = open ? `/api/company/${companyId}/keys/` : ''
  const { response: resp, loaded }: any = useFetch(fetchUrl, {})
  const apiKey = loaded && resp ? resp.apiKey : ''

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (copied) setCopied(false)
    }, 1000)

    return () => clearTimeout(timeout)
  }, [copied])

  return (
    <GenericModal
      heading={'API Keys'}
      show={open}
      size="lg"
      onHide={() => setOpen(false)}
      buttons={
        <>
          {!apiKey && (
            <GlobalStyles.Button onClick={() => usePost(`/api/company/${companyId}/keys/`, {}, csrf)}>
              Create API Key
            </GlobalStyles.Button>
          )}
          <GlobalStyles.Button className="secondary" style={{ minWidth: 125 }} onClick={() => setOpen(false)}>
            Close
          </GlobalStyles.Button>
        </>
      }
    >
      <div style={{ minHeight: 300, padding: '2em', width: '-webkit-fill-available', maxWidth: 700, margin: 'auto' }}>
        <StatusBarStyled style={{ backgroundColor: theme.colors.ghostWhite }}>
          <div className="header-item">
            <div className="status-icon">
              <FontAwesomeIcon icon={faInfoSquare} style={{ color: theme.colors.freshEggplant }} />
            </div>
            <div className="status-text">
              An <strong>API Key</strong> will grant access to Kase's API. Documentation can be found{' '}
              <Link target="_blank" to={'/api/docs/'}>
                here
              </Link>
              .
            </div>
          </div>
        </StatusBarStyled>
        <GlobalStyles.DataTable>
          <thead>
            <tr>
              <th>
                <span className="text">API Key</span>
              </th>
              <th>
                <span className="text center">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {apiKey && (
              <TableRow>
                <TableCell input={'************' + apiKey.substr(apiKey.length - 4)} />
                <TableCell
                  center
                  input={
                    <div className="dropdown__container" style={{ fontSize: '1.2em', minWidth: 80 }}>
                      <button onClick={() => usePost(`/api/company/${companyId}/keys/`, {}, csrf)}>
                        <GlobalStyles.Tooltip data-title="Regenerate API Key">
                          <FontAwesomeIcon icon={faRecycle} />
                        </GlobalStyles.Tooltip>
                      </button>
                      <br />
                      <button>
                        <GlobalStyles.Tooltip data-title="Copy to clipboard">
                          <Clipboard copied={copied} setCopied={setCopied} text={apiKey} color="grey" />
                        </GlobalStyles.Tooltip>
                      </button>
                    </div>
                  }
                />
              </TableRow>
            )}
          </tbody>
        </GlobalStyles.DataTable>
      </div>
    </GenericModal>
  )
}
